import styled from 'styled-components'
import { styles } from 'lib/ui/components/Form/components/Input'

export const Container = styled.div`
  input {
    ${styles}
  }
`
